export default {
  title: 'ที่จอดรถ',

  vehicles: {
    title: 'ยานพาหนะ',
    new_vehicle: 'เพิ่มยานพาหนะ',
    add: 'เพิ่มยานพาหนะ',
    edit: 'แก้ไขยานพาหนะ',
    license_plate: 'ป้ายทะเบียน',
    license_plate_placeholder: 'เช่น กข 1234',
    province: 'จังหวัด',
    vehicle_type: 'ประเภทยานพาหนะ',
    brand: 'ยี่ห้อ',
    model: 'รุ่น',
    color: 'สี',
    notes: 'บันทึก',
    search_placeholder: 'ค้นหาทะเบียน ยี่ห้อ รุ่น สี หรือชื่อลูกค้า…',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบยานพาหนะนี้?',
    delete_has_permits: 'ไม่สามารถลบยานพาหนะที่มีบัตรจอดรถที่ยังใช้งานอยู่',

    types: {
      car: 'รถยนต์',
      motorcycle: 'รถจักรยานยนต์',
      pickup: 'รถกระบะ',
      bicycle: 'จักรยาน',
      van: 'รถตู้',
      // LPR vehicle_type champion vocabulary (EP-85 warm path)
      suv: 'รถอเนกประสงค์ (SUV)',
      truck: 'รถบรรทุก',
      bus: 'รถบัส',
      vehicle: 'ยานพาหนะ',
    },

    empty: {
      title: 'ยังไม่มียานพาหนะที่ลงทะเบียน',
      description: 'ลงทะเบียนยานพาหนะคันแรกเพื่อเริ่มติดตามบัตรจอดรถสำหรับที่พักแห่งนี้',
      no_search_results: 'ไม่พบยานพาหนะที่ตรงกับการค้นหา',
    },

    // EPV-9: parker_type radio + conditional zones
    parker_type: {
      label: 'ประเภทผู้จอด',
      tenant: 'ผู้เช่า',
      external: 'บุคคลภายนอก',
    },
    parker_type_hint: {
      tenant: 'เชื่อมกับสัญญาเช่า ใช้สำหรับออกใบแจ้งหนี้รายเดือน',
      external: 'ผู้จอดภายนอกที่ไม่มีสัญญาเช่า',
    },
    customer_auto_derived: 'ลูกค้าถูกดึงโดยอัตโนมัติจากสัญญาเช่าที่เลือก',
    active_permits_warning: 'ยานพาหนะนี้มีใบอนุญาตจอดรถ {{count}} รายการ การเปลี่ยนประเภทจะไม่อัปเดตใบอนุญาตให้อัตโนมัติ',
    // P0-01: plate_text + photo fields
    plate_text_label: 'ข้อความป้ายทะเบียน (ระบุเอง)',
    plate_text_placeholder: 'เช่น 1กข 1234 หรือข้อความบนป้ายทะเบียน',
    front_photo_label: 'รูปด้านหน้า',
    front_photo_hint: 'รูปถ่ายยานพาหนะจากด้านหน้า',
    rear_photo_label: 'รูปด้านหลัง',
    rear_photo_hint: 'รูปถ่ายยานพาหนะจากด้านหลัง',
    photos_section_label: 'รูปถ่ายยานพาหนะ',
    front_photo_required: 'กรุณาอัปโหลดรูปด้านหน้า',
    rear_photo_required: 'กรุณาอัปโหลดรูปด้านหลัง',
    photo_upload_error: 'อัปโหลดรูปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  },

  zones: {
    title: 'โซนจอดรถ',
    new_zone: 'โซนใหม่',
    add: 'เพิ่มโซน',
    edit: 'แก้ไขโซน',
    name: 'ชื่อโซน',
    zone_type: 'ประเภทโซน',
    total_slots: 'จำนวนช่องทั้งหมด',
    occupied_slots: 'ใช้งานอยู่',
    available_slots: 'ว่าง',
    occupancy: 'อัตราการใช้งาน',
    view_all: 'ดูทั้งหมด',
    full_warning: 'เต็ม',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบโซน "{{name}}"?',
    delete_has_permits: 'ไม่สามารถลบโซนที่มีบัตรจอดรถที่ยังใช้งานอยู่',

    types: {
      car: 'รถยนต์',
      motorcycle: 'รถจักรยานยนต์',
      mixed: 'รวม',
    },

    empty: {
      title: 'ยังไม่มีโซนจอดรถ',
      description: 'สร้างโซนจอดรถเพื่อจัดระเบียบและติดตามความจุที่จอดรถ',
    },

    // ป้าย QR ลงทะเบียนเข้าจอดด้วยตนเอง (EP-105)
    public_checkin: {
      title: 'ลงทะเบียนเข้าจอดด้วยตนเอง',
      description:
        'พิมพ์ QR นี้เป็นสติกเกอร์ติดที่ไม้กั้น ผู้มาจอดสแกนเพื่อลงทะเบียนด้วยทะเบียนรถ + รูปถ่าย แล้วชำระเงินตอนออก',
      not_generated: 'ยังไม่ได้สร้างลิงก์ลงทะเบียนเข้าจอด',
      generate: 'สร้างลิงก์',
      rotate: 'สร้างลิงก์ใหม่',
      rotate_warning: 'การสร้างใหม่จะทำให้สติกเกอร์เดิมใช้ไม่ได้ โปรดพิมพ์ใหม่หลังสร้าง',
      copy_link: 'คัดลอกลิงก์',
      copied: 'คัดลอกแล้ว!',
      print: 'พิมพ์สติกเกอร์',
      download_png: 'ดาวน์โหลด PNG',
      link_label: 'ลิงก์ลงทะเบียนเข้าจอด',
      scan_to_check_in: 'สแกนเพื่อลงทะเบียนเข้าจอด',
      fee_table_title: 'อัตราค่าจอดรถ',
      fee_daily: 'ต่อวัน',
      fee_hourly: 'ต่อชั่วโมง',
      fee_hourly_tier: 'ไม่เกิน {{hours}} ชั่วโมง',
      fee_all_vehicles: 'รถทุกประเภท',
      tiers_title: 'อัตราค่าจอดแบบขั้นบันได',
      tiers_description: 'แต่ละขั้นกำหนดเวลาจอดสูงสุด ระบบจะคิดตามขั้นที่เหมาะสมที่สุด หากจอดนานเกิน 24 ชั่วโมงจะไม่คิดค่าจอดอัตโนมัติ',
      tiers_col_hours: 'จำนวนชั่วโมงสูงสุด',
      tiers_col_amount: 'ค่าจอด (บาท)',
      tiers_add: 'เพิ่มขั้น',
      tiers_remove: 'ลบขั้น',
      tiers_count: '{{count}}/6 ขั้น',
      tier_validation_hours_range: 'จำนวนชั่วโมงสูงสุดต้องอยู่ระหว่าง 1 ถึง 24',
      tier_validation_amount_positive: 'ค่าจอดต้องไม่ติดลบ',
      tier_validation_sorted: 'ขั้นต้องเรียงจากน้อยไปมากตามจำนวนชั่วโมงสูงสุด',
      tier_validation_unique: 'จำนวนชั่วโมงสูงสุดห้ามซ้ำกัน',
    },
  },

  permits: {
    title: 'บัตรจอดรถ',
    new_permit: 'บัตรจอดรถใหม่',
    add: 'เพิ่มบัตรจอดรถ',
    edit: 'แก้ไขบัตรจอดรถ',
    permit_type: 'ประเภทบัตร',
    slot_number: 'หมายเลขช่องจอด',
    sticker_number: 'หมายเลขสติกเกอร์/บัตร',
    monthly_fee: 'ค่าจอดรถรายเดือน',
    daily_fee: 'ค่าจอดรถรายวัน',
    started_at: 'วันที่เริ่มต้น',
    ended_at: 'วันที่สิ้นสุด',
    status: 'สถานะ',
    cancel_permit: 'ยกเลิกบัตรจอดรถ',
    cancel_confirm: 'ยกเลิกบัตรจอดรถนี้หรือไม่? วันที่สิ้นสุดจะถูกตั้งเป็นวันนี้',
    search_placeholder: 'ค้นหาป้ายทะเบียน...',
    // EPV-10: auto-fill from vehicle.lease_summary
    lease_auto_filled: 'กรอกสัญญาเช่าอัตโนมัติจากยานพาหนะ',
    override_lease: 'เปลี่ยน',

    types: {
      tenant_included: 'รวมในสัญญาเช่า',
      tenant_addon: 'ผู้เช่าเพิ่มเติม',
      monthly_external: 'บุคคลภายนอกรายเดือน',
      daily_external: 'บุคคลภายนอกรายวัน',
    },

    statuses: {
      active: 'ใช้งานอยู่',
      expired: 'หมดอายุ',
      cancelled: 'ยกเลิกแล้ว',
    },

    empty: {
      title: 'ยังไม่มีบัตรจอดรถ',
      description: 'สร้างบัตรจอดรถเพื่อกำหนดช่องจอดให้กับยานพาหนะ',
    },
  },

  fee_configs: {
    title: 'ตั้งค่าค่าจอดรถ',
    vehicle_type: 'ประเภทยานพาหนะ',
    included_spots: 'จำนวนช่องที่รวมอยู่',
    addon_monthly_fee: 'ค่าเพิ่มเติมรายเดือน (บาท)',
    external_monthly_fee: 'บุคคลภายนอกรายเดือน (บาท)',
    external_daily_fee: 'บุคคลภายนอกรายวัน (บาท)',
    save_all: 'บันทึกทั้งหมด',
    saved: 'บันทึกตั้งค่าค่าจอดรถเรียบร้อยแล้ว',
  },

  daily_logs: {
    title: 'บันทึกจอดรถรายวัน',
    record_daily: 'บันทึกรายการ',
    add: 'บันทึกรายการ',
    license_plate: 'ป้ายทะเบียน',
    license_plate_placeholder: 'เช่น กข 1234',
    vehicle_type: 'ประเภทยานพาหนะ',
    parker_name: 'ชื่อผู้จอด',
    parker_phone: 'เบอร์โทรศัพท์',
    fee: 'ค่าจอด (บาท)',
    payment_method: 'วิธีชำระเงิน',
    entered_at: 'เวลาเข้า',
    exited_at: 'เวลาออก',
    daily_total: 'ยอดรวมประจำวัน',
    still_parked: 'ยังจอดอยู่',
    exit: 'ออกแล้ว',
    exit_confirm: 'บันทึกว่ายานพาหนะออกแล้วหรือไม่? เวลาออกจะถูกตั้งเป็นปัจจุบัน',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกจอดรถนี้?',
    date_label: 'วันที่',
    notes: 'บันทึก',

    payment_methods: {
      cash: 'เงินสด',
      transfer: 'โอนเงิน',
      promptpay: 'พร้อมเพย์',
    },

    empty: {
      title: 'ยังไม่มีบันทึกจอดรถ',
      description: 'บันทึกรายการจอดรถรายวันสำหรับผู้มาเยือนและยานพาหนะภายนอก',
    },
  },

  lpr: {
    title: 'เหตุการณ์ LPR',
    description: 'การตรวจจับป้ายทะเบียนจากกล้อง อัปเดตอัตโนมัติทุก 10 วินาที',
    // New schema fields (P2-04)
    captured_at: 'เวลาจับภาพ',
    plate_text: 'ป้ายทะเบียน',
    camera: 'กล้อง',
    best_candidate: 'ตัวเลือกที่ดีที่สุด',
    verification_status: 'สถานะ',
    thumbnail: 'ภาพ',
    thumbnail_alt: 'ภาพยานพาหนะ',
    thumbnail_unavailable: 'ไม่มีภาพ',
    // Legacy fields
    detected_at: 'ตรวจพบเมื่อ',
    license_plate: 'ป้ายทะเบียน',
    direction: 'ทิศทาง',
    status: 'สถานะ',
    confidence: 'ความเชื่อมั่น',

    directions: {
      entry: 'เข้า',
      exit: 'ออก',
      // EP-106: raw ML classifier values stored in lpr_events.direction
      in: 'เข้า',
      out: 'ออก',
      parked: 'จอดอยู่',
      unclear: 'ไม่ชัดเจน',
    },

    // EP-106: champion vehicle_type classifier (7 classes)
    vehicle_types: {
      car: 'รถยนต์',
      suv: 'รถอเนกประสงค์',
      pickup: 'รถกระบะ',
      truck: 'รถบรรทุก',
      bus: 'รถบัส',
      motorcycle: 'รถจักรยานยนต์',
      unknown: 'ไม่ทราบ',
    },

    // EP-106: champion vehicle_color classifier (17 classes)
    colors: {
      white: 'ขาว',
      black: 'ดำ',
      silver: 'เงิน',
      grey: 'เทา',
      red: 'แดง',
      blue: 'น้ำเงิน',
      brown: 'น้ำตาล',
      yellow: 'เหลือง',
      green: 'เขียว',
      orange: 'ส้ม',
      purple: 'ม่วง',
      pink: 'ชมพู',
      beige: 'ครีม',
      gold: 'ทอง',
      'two-tone': 'สองสี',
      other: 'อื่นๆ',
      unknown: 'ไม่ทราบ',
    },

    statuses: {
      unprocessed: 'ยังไม่ประมวลผล',
      matched: 'ตรงกัน',
      unmatched: 'ไม่ตรงกัน',
      error: 'ข้อผิดพลาด',
    },

    verification_statuses: {
      pending: 'รอตรวจสอบ',
      verified_success: 'ตรวจสอบแล้ว',
      verified_failed: 'ไม่ผ่าน',
    },

    // T148-007 (EP-148 Part B): unpaid-candidate visibility, spec §5.
    candidate: {
      badge: 'ค้างจ่าย',
      resolved_paid: 'ยืนยันว่าชำระแล้ว',
      session_label: 'เซสชัน #{{id}}',
      tooltip: 'ระยะห่าง {{distance}} · ความมั่นใจ {{confidence}}%',
    },

    // T148A-007 (EP-148 Amendment A, ruling i): operator "Settle & check out"
    // action on an unresolved unpaid-candidate row.
    settle: {
      action: 'ชำระและออกจากที่จอด',
      modal_title: 'ชำระเงินสำหรับที่จอดรถ #{{id}}',
      amount_label: 'ยอดเงิน (บาท)',
      payment_method_label: 'วิธีชำระเงิน',
      payment_method_cash: 'เงินสด',
      payment_method_transfer: 'โอนเงิน',
      cancel: 'ยกเลิก',
      save: 'ชำระและออกจากที่จอด',
      success: 'ชำระและออกจากที่จอดเรียบร้อยแล้ว',
      error_already_settled: 'ที่จอดนี้ถูกชำระแล้ว',
      error_generic: 'ไม่สามารถชำระที่จอดนี้ได้ กรุณาลองอีกครั้ง',
    },

    filters: {
      all: 'ทั้งหมด',
      pending: 'รอตรวจสอบ',
      verified: 'ตรวจสอบแล้ว',
      failed: 'ไม่ผ่าน',
      all_statuses: 'ทุกสถานะ',
      date_from: 'ตั้งแต่',
      date_to: 'ถึง',
      filter_label: 'ตัวกรอง',
      // EP-106: attribute filter chrome keys
      plate_placeholder: '1กก 1234',
      vehicle_type: 'ประเภทยานพาหนะ',
      color: 'สี',
      direction: 'ทิศทาง',
      clear: 'ล้าง',
      clear_plate: 'ล้างตัวกรองป้ายทะเบียน',
      active_count: '{{count}}',
      widen_date_hint: 'ไม่พบผลลัพธ์ ลองขยายช่วงวันที่',
      // T148-007: standalone toggle, orthogonal to the verification chips above.
      candidates_only: 'เฉพาะรายการค้างจ่าย',
    },

    empty: {
      title: 'ไม่มีเหตุการณ์ LPR',
      description: 'การตรวจจับป้ายทะเบียนจะปรากฏที่นี่เมื่อบริการ LPR ทำงานอยู่',
    },

    verification_drawer: {
      title: 'ตรวจสอบเหตุการณ์',
      aria_label: 'การตรวจสอบเหตุการณ์ LPR',
      captured_event: 'เหตุการณ์ที่จับภาพ',
      candidate_vehicle: 'ยานพาหนะที่คาดการณ์',
      front: 'ด้านหน้า',
      rear: 'ด้านหลัง',
      registered_front: 'ภาพหน้าที่ลงทะเบียน',
      registered_rear: 'ภาพหลังที่ลงทะเบียน',
      registered_photo_alt: 'ภาพยานพาหนะที่ลงทะเบียน',
      no_registered_photo: 'ไม่มีภาพที่ลงทะเบียน',
      vehicle_type: 'ประเภท',
      color: 'สี',
      last_seen: 'พบล่าสุด',
      vehicle_not_found: 'ไม่พบยานพาหนะ',
      verify_success: 'ยืนยันสำเร็จ',
      verify_failed: 'ยืนยันไม่ผ่าน',
      leave_unmapped: 'ไม่ระบุยานพาหนะ',
      select_reasons: 'เลือกเหตุผลที่ไม่ผ่าน',
      submit_failed: 'ส่ง',
      note_placeholder: 'หมายเหตุ (ไม่บังคับ)...',
      last_verified_by: 'ตรวจสอบล่าสุดโดย {{name}} เมื่อ {{time}}',
      link_vehicle: 'ผูกยานพาหนะ',
      search_vehicle_placeholder: 'ค้นหาทะเบียนหรือยี่ห้อ…',
      search_min_chars: 'พิมพ์อย่างน้อย 2 ตัวอักษร',
      no_vehicles_found: 'ไม่พบยานพาหนะที่ตรงกัน',
      clear_selection: 'ล้าง',
      searching_vehicles: 'กำลังค้นหายานพาหนะ…',
      link_and_verify: 'ผูกและยืนยัน',
      reasons: {
        text: 'ป้ายทะเบียนไม่ตรง',
        color: 'สีไม่ตรง',
        type: 'ประเภทยานพาหนะไม่ตรง',
        blurry: 'ภาพเบลอ',
        occluded: 'ถูกบดบัง',
        dark: 'มืด / แสงน้อย',
        glare: 'แสงสะท้อน',
        no_plate: 'ไม่เห็นป้ายทะเบียน',
        not_a_vehicle: 'ไม่ใช่ยานพาหนะ / ครอปผิด',
        partial: 'ภาพไม่ครบ',
        duplicate: 'รายการซ้ำ',
        unknown: 'เหตุผลอื่น',
      },
    },

    reconciliation_table: {
      section_label: 'เปรียบเทียบข้อมูล',
      attribute: 'คุณลักษณะ',
      ml_to_registered: 'ML → ที่ลงทะเบียน',
      brand_model: 'ยี่ห้อ / รุ่น',
      direction_label: 'ทิศทางที่ผู้ปฏิบัติการกำหนด',
      match: '(ตรงกัน)',
      mismatch: '(ไม่ตรงกัน)',
    },
  },

  reports: {
    occupancy_title: 'รายงานการใช้งานที่จอดรถ',
    revenue_title: 'รายงานรายได้ที่จอดรถ',
    registry_title: 'รายงานทะเบียนยานพาหนะ',
    total_vehicles: 'ยานพาหนะทั้งหมด',
    monthly_revenue: 'รายได้รายเดือน',
    expiring_permits: 'บัตรจอดรถที่ใกล้หมดอายุ',
    expiring_soon: '{{count}} รายการ หมดอายุใน {{days}} วัน',
  },

  // EP-161: ที่จอดรถวันนี้, the day's visitor cars of one property.
  sessions: {
    title: 'ที่จอดรถวันนี้',
    states: {
      parked: 'จอดอยู่',
      overstay: 'เกินเวลา',
      awaiting_payment: 'รอชำระ',
      slip_to_verify: 'สลิปรอตรวจ',
      rejected: 'ไม่ผ่าน',
      paid: 'ชำระแล้ว',
    },
    tabs: {
      all: 'ทั้งหมด',
      aria_label: 'สถานะ',
    },
    search_plate: 'ค้นหาทะเบียน',
    date_label: 'วันที่',
    all_days: 'ทุกวัน',
    plate: 'ทะเบียน',
    zone: 'โซน',
    entered: 'เข้า',
    exited: 'ออก',
    amount: 'ค่าจอด',
    state: 'สถานะ',
    actions: 'การจัดการ',
    view_slip: 'ดูสลิป',
    verify: 'ตรวจผ่าน',
    reject: 'ไม่ผ่าน',
    fraud_mark: 'แจ้งทุจริต',
    fraud_badge: 'แจ้งทุจริต',
    plate_flagged: 'ทะเบียนนี้เคยถูกแจ้งทุจริต',
    slip: 'สลิป',
    car_photo: 'รูปรถตอนจ่าย',
    entry_photo: 'รูปตอนเข้าจอด',
    cash_photo: 'รูปเงินสด',
    server_time: '(เวลาจากระบบ)',
    history: 'ประวัติการตรวจ',
    reference: 'อ้างอิง',
    reject_reason: 'เหตุผล',
    fraud_by: 'แจ้งโดย {{name}}',
    show_detail: 'ดูรายละเอียด',
    hide_detail: 'ซ่อนรายละเอียด',
    verified_by: {
      slip_checked: 'ตรวจสลิปแล้ว',
      cash: 'รับเงินสด',
      transfer: 'รับเงินโอน',
      bank_match: 'ตรงกับรายการเดินบัญชี',
      ml: 'ระบบตรวจอัตโนมัติ',
    },
    empty: 'ไม่มีรถในรายการนี้',
    fraud_modal: {
      title: 'แจ้งทุจริต',
      body: 'รายการชำระของรถคันนี้จะถูกปฏิเสธ และระบบจะบันทึกทะเบียนนี้ไว้',
      reason_label: 'เหตุผล',
      submit: 'แจ้งทุจริต',
      success: 'แจ้งทุจริตแล้ว',
    },
    errors: {
      reason_required: 'กรุณาระบุเหตุผล',
      already_flagged: 'รถคันนี้ถูกแจ้งทุจริตไปแล้ว',
      already_paid: 'รถคันนี้ชำระแล้ว แจ้งทุจริตไม่ได้',
      not_checked_out: 'รถยังจอดอยู่ ให้เช็กเอาต์ก่อน',
    },
    // EP-161 §2.3, S6 (T161-W02a): the gate, in the operator app only.
    gate: {
      check_out: 'เช็กเอาต์',
      use_mobile_app: 'ใช้แอป FlowRent บนมือถือ',
      sheet_title: 'เช็กเอาต์ {{plate}}',
      entered_at: 'เข้า {{time}}',
      duration: 'จอด {{duration}}',
      duration_hours_minutes: '{{hours}} ชม. {{minutes}} นาที',
      duration_minutes: '{{minutes}} นาที',
      charge: 'ค่าจอด {{amount}}',
      scan_to_pay: 'ให้ผู้ขับสแกนจ่าย',
      qr_label: 'QR พร้อมเพย์สำหรับค่าจอด',
      no_qr: 'รายการนี้ไม่มี QR ให้รับเงินสดหรือตรวจการโอนแทน',
      take_cash: 'รับเงินสด',
      verify: 'ตรวจผ่าน',
      verify_at_gate_reason: 'ตรวจที่ป้อม',
      close: 'ปิด',
      cash_title: 'รับเงินสด {{plate}}',
      cash_amount_from_charge: 'ยอด {{amount}} (จากค่าจอด)',
      cash_amount_label: 'ยอดเงิน (บาท)',
      take_cash_photo: 'ถ่ายรูปเงินสด',
      cash_photo_hint: 'ถ่ายรูปเงินสดก่อนบันทึก',
      uploading_photo: 'กำลังส่งรูป',
      retake: 'ถ่ายใหม่',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      cash_saved: 'บันทึกการรับเงินสดแล้ว',
      errors: {
        cash_photo_required: 'ถ่ายรูปเงินสดก่อนบันทึก',
        cash_photo_invalid: 'ใช้รูปนี้ไม่ได้ ถ่ายใหม่อีกครั้ง',
        cash_photo_stale: 'รูปนี้นานเกินไป ถ่ายใหม่อีกครั้ง',
        already_settled: 'รถคันนี้ชำระแล้ว',
        already_paid: 'รถคันนี้ชำระแล้ว',
        invalid_amount: 'ยอดเงินต้องมากกว่า 0',
        amount_required: 'กรุณาระบุยอดเงิน',
        already_exited: 'รถคันนี้เช็กเอาต์ไปแล้ว',
        no_fee_configured: 'โซนนี้ยังไม่ได้ตั้งค่าจอด',
        overstay_contact_admin: 'รถจอดเกินเวลาที่ตู้คิดค่าได้ รับเงินสดตามยอดที่ตกลง',
        upload_failed: 'ส่งรูปไม่สำเร็จ ลองอีกครั้ง',
        check_out_failed: 'เช็กเอาต์ไม่สำเร็จ ลองอีกครั้ง',
        failed: 'บันทึกไม่สำเร็จ ลองอีกครั้ง',
      },
    },
  },

  list_page: {
    select_property: 'เลือกอสังหาริมทรัพย์',
    no_property_selected: 'ยังไม่ได้เลือกอสังหาริมทรัพย์',
    parking_modules: 'โมดูลที่จอดรถ',
  },

  labels: {
    license_plate: 'ป้ายทะเบียน',
    vehicle_type: 'ประเภทยานพาหนะ',
    brand: 'ยี่ห้อ',
    model: 'รุ่น',
    color: 'สี',
    province: 'จังหวัด',
    zone_name: 'ชื่อโซน',
    zone_type: 'ประเภทโซน',
    total_slots: 'จำนวนช่องทั้งหมด',
    occupied_slots: 'ใช้งานอยู่',
    available_slots: 'ว่าง',
    slot_number: 'หมายเลขช่องจอด',
    sticker_number: 'หมายเลขสติกเกอร์/บัตร',
    permit_type: 'ประเภทบัตร',
    monthly_fee: 'ค่าจอดรายเดือน',
    daily_fee: 'ค่าจอดรายวัน',
    started_at: 'วันที่เริ่มต้น',
    ended_at: 'วันที่สิ้นสุด',
    status: 'สถานะ',
    parker_name: 'ชื่อผู้จอด',
    parker_phone: 'เบอร์โทรศัพท์',
    fee: 'ค่าจอด (บาท)',
    payment_method: 'วิธีชำระเงิน',
    entered_at: 'เวลาเข้า',
    exited_at: 'เวลาออก',
    notes: 'บันทึก',
    manage_vehicles: 'ลงทะเบียนและติดตามยานพาหนะ',
    manage_zones: 'กำหนดพื้นที่จอดรถ',
    manage_permits: 'กำหนดใบอนุญาตจอดรถ',
    manage_daily_logs: 'บันทึกจอดรถรายวัน',
    manage_fees: 'กำหนดอัตราค่าจอดรถ',
  },

  actions: {
    new_vehicle: 'เพิ่มยานพาหนะ',
    new_zone: 'โซนใหม่',
    new_permit: 'บัตรจอดรถใหม่',
    record_daily: 'บันทึกรายการ',
    cancel_permit: 'ยกเลิกบัตรจอดรถ',
  },

  messages: {
    vehicle_created: 'ลงทะเบียนยานพาหนะแล้ว',
    vehicle_updated: 'อัปเดตยานพาหนะแล้ว',
    vehicle_deleted: 'ลบยานพาหนะแล้ว',
    zone_created: 'สร้างโซนจอดรถแล้ว',
    zone_updated: 'อัปเดตโซนจอดรถแล้ว',
    zone_deleted: 'ลบโซนจอดรถแล้ว',
    permit_created: 'สร้างบัตรจอดรถแล้ว',
    permit_updated: 'อัปเดตบัตรจอดรถแล้ว',
    permit_cancelled: 'ยกเลิกบัตรจอดรถแล้ว',
    log_created: 'บันทึกรายการจอดรถแล้ว',
    log_updated: 'อัปเดตบันทึกจอดรถแล้ว',
    log_deleted: 'ลบบันทึกจอดรถแล้ว',
    fee_config_saved: 'บันทึกตั้งค่าค่าจอดรถเรียบร้อยแล้ว',
    zone_at_capacity_warning: 'โซนนี้เต็มความจุแล้ว',
  },

  filters: {
    all: 'ทั้งหมด',
    all_types: 'ทุกประเภท',
    all_statuses: 'ทุกสถานะ',
    active: 'ใช้งานอยู่',
    expired: 'หมดอายุ',
    cancelled: 'ยกเลิกแล้ว',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
  },

  validation: {
    license_plate_required: 'กรุณากรอกป้ายทะเบียน',
    vehicle_type_required: 'กรุณาเลือกประเภทยานพาหนะ',
    duplicate_license_plate: 'มียานพาหนะที่ใช้ป้ายทะเบียนนี้อยู่แล้ว',
    monthly_fee_required: 'กรุณากรอกค่าจอดรถรายเดือน',
    started_at_required: 'กรุณาระบุวันที่เริ่มต้น',
    total_slots_min: 'จำนวนช่องต้องมีอย่างน้อย 1 ช่อง',
    zone_at_capacity_warning: 'โซนนี้เต็มความจุแล้ว',
    included_spots_non_negative: 'จำนวนต้องเป็นจำนวนเต็มที่ไม่ติดลบ',
    fee_non_negative: 'จำนวนต้องเป็น 0 หรือมากกว่า',
    // EPV-9: parker_type validation
    lease_required: 'กรุณาเลือกสัญญาเช่าสำหรับยานพาหนะผู้เช่า',
    customer_required_for_external: 'กรุณาเลือกลูกค้าสำหรับยานพาหนะภายนอก',
    // P0-01: plate_text validation
    plate_text_required: 'กรุณากรอกข้อความป้ายทะเบียน',
  },

  setup_guide: {
    title: 'เริ่มต้นใช้งานที่จอดรถ',
    description: 'ติดตามยานพาหนะ จัดการโซนจอดรถ และออกบัตรจอดรถ',
    prerequisites_title: 'สิ่งที่ต้องมี',
    prereq_property: 'อสังหาริมทรัพย์อย่างน้อย 1 แห่ง',
    prereq_setup_property: 'ตั้งค่าอสังหาริมทรัพย์',
    steps: {
      create_zone: {
        title: 'สร้างโซนจอดรถ',
        description: 'กำหนดพื้นที่จอดรถพร้อมจำนวนช่องสูงสุด',
      },
      register_vehicle: {
        title: 'ลงทะเบียนยานพาหนะ',
        description: 'เพิ่มยานพาหนะของผู้เช่าและผู้มาเยือน',
      },
      issue_permit: {
        title: 'ออกบัตรจอดรถ',
        description: 'กำหนดช่องจอดให้กับยานพาหนะ',
      },
    },
    empty: {
      title: 'ยังไม่มีข้อมูลที่จอดรถ',
      description: 'เริ่มต้นด้วยการสร้างโซนจอดรถสำหรับที่พักแห่งนี้',
    },
    zones: {
      title: 'เริ่มต้นใช้งานโซนจอดรถ',
      description: 'กำหนดพื้นที่จอดรถพร้อมจำนวนช่องสูงสุดเพื่อจัดระเบียบที่จอดรถ',
      steps: {
        create_zone: {
          title: 'สร้างโซนจอดรถ',
          description: 'กำหนดชื่อโซนและประเภท (รถยนต์, รถจักรยานยนต์ หรือรวม)',
        },
        set_capacity: {
          title: 'กำหนดจำนวนช่อง',
          description: 'ระบุจำนวนช่องจอดรถทั้งหมดที่มี',
        },
        monitor: {
          title: 'ติดตามการใช้งาน',
          description: 'ดูจำนวนช่องที่ใช้งานและว่างแบบเรียลไทม์',
        },
      },
    },
    permits: {
      title: 'เริ่มต้นใช้งานบัตรจอดรถ',
      description: 'กำหนดช่องจอดให้กับผู้เช่าและบุคคลภายนอก',
      prereq_vehicles: 'ลงทะเบียนยานพาหนะอย่างน้อย 1 คัน',
      prereq_setup_vehicles: 'ลงทะเบียนยานพาหนะ',
      prereq_zones: 'สร้างโซนจอดรถอย่างน้อย 1 โซน',
      prereq_setup_zones: 'สร้างโซน',
      steps: {
        register_vehicle: {
          title: 'ลงทะเบียนยานพาหนะ',
          description: 'เพิ่มยานพาหนะของผู้เช่าและผู้มาเยือนก่อน',
        },
        create_zone: {
          title: 'สร้างโซนจอดรถ',
          description: 'กำหนดพื้นที่จอดรถพร้อมจำนวนช่องสูงสุด',
        },
        issue_permit: {
          title: 'ออกบัตรจอดรถ',
          description: 'กำหนดช่องจอดและตั้งค่าประเภทบัตรและค่าบริการ',
        },
      },
    },
    daily_logs: {
      title: 'เริ่มต้นใช้งานจอดรถรายวัน',
      description: 'ติดตามและเก็บค่าจอดรถสำหรับผู้มาเยือนรายวัน',
      prereq_fee_configs: 'ตั้งค่าอัตราค่าจอดรถแล้ว',
      prereq_setup_fees: 'ตั้งค่าค่าจอดรถ',
      prereq_zones: 'สร้างโซนจอดรถอย่างน้อย 1 โซน',
      prereq_setup_zones: 'สร้างโซน',
      steps: {
        configure_fees: {
          title: 'ตั้งค่าอัตราค่าจอดรถ',
          description: 'กำหนดค่าจอดรายวันตามประเภทยานพาหนะ',
        },
        log_entry: {
          title: 'บันทึกรายการเข้า',
          description: 'บันทึกป้ายทะเบียน ประเภทยานพาหนะ และเวลาเข้า',
        },
        record_exit: {
          title: 'บันทึกรายการออก',
          description: 'บันทึกเวลาออกและเก็บค่าจอดรถ',
        },
      },
    },
  },

  errors: {
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',
    duplicate_permit: 'มีใบอนุญาตสำหรับยานพาหนะนี้อยู่แล้ว',

    fields: {
      permit_type: 'ประเภทใบอนุญาต',
      vehicle_id: 'ยานพาหนะ',
      parking_zone_id: 'โซนจอดรถ',
      lease_id: 'สัญญาเช่า',
      monthly_fee: 'ค่าจอดรายเดือน',
      daily_fee: 'ค่าจอดรายวัน',
      started_at: 'วันที่เริ่ม',
      ended_at: 'วันที่สิ้นสุด',
      license_plate: 'ป้ายทะเบียน',
    },

    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      greater_than: 'ต้องมากกว่าค่าที่กำหนด',
      greater_than_or_equal_to: 'ต้องมากกว่าหรือเท่ากับค่าที่กำหนด',
      less_than: 'ต้องน้อยกว่าค่าที่กำหนด',
      less_than_or_equal_to: 'ต้องน้อยกว่าหรือเท่ากับค่าที่กำหนด',
      not_a_number: 'ต้องเป็นตัวเลข',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
    },
    // EPV-10: client-side permit_type vs vehicle parker_type mismatch
    permit_type_mismatch_with_external_vehicle: 'ประเภทบัตรสำหรับผู้เช่า (tenant_included, tenant_addon) ไม่สามารถใช้กับยานพาหนะภายนอกได้',
  },
}
